import { clsx } from "clsx";

export default function IconHouse({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8351 4.03125L16.3038 4.34375L4.80383 11.5625L5.83508 13.1875V16H7.83508V12L16.8351 6.40625L25.8351 12.0313V16H27.8351V13.1875L28.8663 11.5625L17.3663 4.34375L16.8351 4.03125ZM5.83508 18V22H7.83508V18H5.83508ZM25.8351 18V22H27.8351V18H25.8351ZM5.83508 24V28H9.83508V26H7.83508V24H5.83508ZM25.8351 24V26H23.8351V28H27.8351V24H25.8351ZM11.8351 26V28H15.8351V26H11.8351ZM17.8351 26V28H21.8351V26H17.8351Z"
        fill="currentColor"
      />
    </svg>
  );
}
